import {Injectable } from '@angular/core';
import {HttpClient, HttpHeaders } from '@angular/common/http';
import {JwtHelperService  } from '@auth0/angular-jwt';
import * as jwt_decode from 'jwt-decode';
import {environment} from 'src/environments/environment';

@Injectable({providedIn: 'root'})
export class ServicesCommon {
    public url: string;

    // tslint:disable-next-line: variable-name
    constructor(private _http: HttpClient, public jwtHelper: JwtHelperService) {
        this.url = environment.urlAddressCommon;
    }


    claseVehiculo() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const decode = jwt_decode(token);
        return this._http.get(environment.urlAddressCommon + 'vehiculos/clases');
    }


    marcasVehiculo() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const decode = jwt_decode(token);
        return this._http.get(environment.urlAddressCommon + 'vehiculos/marcas');
    }


    serviciostipoVehiculo() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const decode = jwt_decode(token);
        return this._http.get(environment.urlAddressCommon + 'vehiculos/serviciosTipos');
    }

    tiposEsquema() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const decode = jwt_decode(token);
        return this._http.get(environment.urlAddressCommon + 'esquemasPago/tipos');
    }

    productosEsquema() {
        const token = sessionStorage.getItem('token');
        const usuarioID = sessionStorage.getItem('usuarioID');
        const decode = jwt_decode(token);
        return this._http.get(environment.urlAddressCommon + 'esquemasPago/productos');
    }

    tipoDocumentosNatural() {
        return this._http.get(environment.urlAddressCommon + 'documentosTipos/personaNatural');
    }

    obtenerTipoMediosPagos(){
        return this._http.get(environment.urlAddressCommon + 'metodosPago/obtenerMetodosPagosTipos');
    }

    obtenerMetodosPagos(tipoID :number){
        return this._http.get(environment.urlAddressCommon + 'metodosPago/obtenerMetodosPagos/'+ tipoID);
    }



    tipoDocumentosJuridica() {
        return this._http.get(environment.urlAddressCommon + 'documentosTipos/personaJuridica');
    }


    tipoVia() {
        return this._http.get(environment.urlAddressCommon + 'direcciones/viasTipos');
    }

    ComplementoVia() {
        return this._http.get(environment.urlAddressCommon + 'direcciones/viasTipos/complementos');
    }

    TipoInmueble() {
        return this._http.get(environment.urlAddressCommon + 'direcciones/inmueblesTipos');
    }

    Departamento() {
        return this._http.get(environment.urlAddressCommon + 'direcciones/departamentos');
    }

    Municipio() {
        return this._http.get(environment.urlAddressCommon + 'direcciones/departamentos/0/municipios');
    }

    Bancos() {
        return this._http.get(environment.urlAddressCommon + 'esquemasPago/bancos');
    }

    TipoCuentas() {
        return this._http.get(environment.urlAddressCommon + 'esquemasPago/cuentas');
    }

    obtenerCasosGrupos() {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressCommon + 'pqrs/obtenerGrupos/' ,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }
    
    obtenerCasosTipos() {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressCommon + 'pqrs/obtenerTipos/',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }
    
    obtenerCasosSubgrupos(grupoID: number) {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressCommon + 'pqrs/obtenerSubgrupos/'+ grupoID,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    obtenerAtencionMediosRespuesta() {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressCommon + 'pqrs/obtenerAtencionMediosRespuesta/',
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    repoteComisiones (inicio, fin) {
        const token = sessionStorage.getItem('token');

        return this._http.get(environment.urlAddressCommon + 'reportes/comisiones/'+ sessionStorage.getItem('comercioID') + '/' + inicio + '/'+ fin,
            {
                headers: new HttpHeaders({
                    Authorization: 'Bearer ' + token,
                    'Content-Type': 'application/json'
                })
            });
    }

    FacturacionConceptosBilletera() {
        return this._http.get(environment.urlAddressCommon + 'Billetera/listarFacturacionConceptosBilletera');
    }

}
